<footer class="bg-white border-t py-6 mt-4 md:mt-8 xl:mt-12 overflow-hidden">
  <div class="content-section mx-auto w-full space-y-6 lg:space-y-10">
    <div
      class="f-reveal flex flex-col md:flex-row items-start lg:items-center justify-between gap-4"
    >
      <p class="-inset-1 font-medium text-xl lg:text-4xl">
        {{ 'Shamstore' | translate }}
      </p>
      <div class="flex flex-col md:flex-row gap-2 md:gap-6 w-full md:w-fit">
        <div>
          <p class="font-medium text-base lg:text-2xl">
            {{ 'Subscribe to Our Newsletter' | translate }}
          </p>
          <p class="text-xs lg:text-sm text-white-dark-a">
            Lorem, ipsum dolor sit amet consectetur adipisicing elit.
          </p>
        </div>
        <form class="flex">
          <input
            class="input input-lg rounded-full text-sm w-4/5 lg:w-3xs ps-6 pe-10\ transition-all duration-200 focus:ring-1 focus:ring-blue/20 focus:border-blue focus:scale-[1.01] focus:shadow-sm outline-none"
            [placeholder]="'Your email address' | translate"
          />
          <button
            type="submit"
            class="subscribe-btn btn btn-lg rounded-full btn-primary -ms-10 z-10 text-sm w-40 hover:bg-blue-dark-h bg-blue-active transition-all"
          >
            {{ 'Subscribe' | translate }}
          </button>
        </form>
      </div>
    </div>
    <div
      class="f-reveal f-delay-1 flex md:flex-row flex-wrap justify-between [&_nav]:w-1/2 [&_nav]:lg:w-fit [&_nav]:space-y-3 [&_nav_ul]:space-y-2 [&_nav_ul]:text-xs [&_nav_ul]:lg:text-sm [&_nav_ul]:text-white-dark-a gap-y-4"
    >
      <div class="space-y-2 md:space-y-4 lg:w-3/10">
        <p class="-inset-1 font-medium text-base lg:text-xl">
          {{ 'About Shamstore' | translate }}
        </p>
        <p class="text-xs lg:text-sm text-white-dark-a">
          {{ 'Your premier destination for online shopping' | translate }}
        </p>
        <p class="-inset-1 font-medium text-base lg:text-xl">
          {{ 'Shop on the Go' | translate }}
        </p>
        <div class="space-x-2">
          <!--  Google Play -->
          <button
            class="btn btn-lg border-0 rounded-selector bg-white-light group transition-all duration-300 ease-in-out hover:shadow-md hover:-translate-y-1 active:scale-95 active:translate-y-0"
          >
            <sham-i-playstore
              class="transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6"
            />

            <div class="text-start text-xs">
              <small class="font-normal text-gray-500 group-hover:text-gray-700">{{
                'Get on' | translate
              }}</small>
              <p class="font-semibold transition-colors duration-300">
                {{ 'Google Play' | translate }}
              </p>
            </div>
          </button>

          <!--  Apple Store -->
          <button
            class="btn btn-lg border-0 rounded-selector bg-white-light group transition-all duration-300 ease-in-out hover:shadow-md hover:-translate-y-1 active:scale-95 active:translate-y-0"
          >
            <sham-i-apple
              class="transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-6"
            />

            <div class="text-start text-xs">
              <small class="font-normal text-gray-500 group-hover:text-gray-700">{{
                'Get on' | translate
              }}</small>
              <p
                class="font-semibold transition-colors duration-300 group-hover:text-black"
              >
                {{ 'Apple Store' | translate }}
              </p>
            </div>
          </button>
        </div>
      </div>
      <nav>
        <h2 class="-inset-1 font-medium text-base lg:text-xl">
          {{ 'SUPPORT' | translate }}
        </h2>
        <ul>
          <li>
            <a routerLink="/contact-us" class="cursor-pointer">{{
              'Contact Us' | translate
            }}</a>
          </li>
          <li>
            <a routerLink="/in-progress" class="cursor-pointer">{{
              'Faqs' | translate
            }}</a>
          </li>
          <li>
            <a routerLink="/in-progress" class="cursor-pointer">{{
              'Terms & Condition' | translate
            }}</a>
          </li>
          <li>
            <a routerLink="/in-progress" class="cursor-pointer">{{
              'Privacy Policy' | translate
            }}</a>
          </li>
        </ul>
      </nav>
      <nav>
        <h2 class="-inset-1 font-medium text-base lg:text-xl">
          {{ 'Account' | translate }}
        </h2>
        <ul>
          <li>
            <a routerLink="/profile" class="cursor-pointer">{{
              'My Account' | translate
            }}</a>
          </li>
          <li>
            <a routerLink="/profile/orders" class="cursor-pointer">{{
              'Order History' | translate
            }}</a>
          </li>
          <li>
            <a routerLink="/wishlist" class="cursor-pointer">{{
              'Wishlist' | translate
            }}</a>
          </li>
          <!-- <li>
            <a routerLink="/profile" class="cursor-pointer">{{ 'Account Settings' | translate }}</a>
          </li> -->
        </ul>
      </nav>
      <nav class="hidden lg:block">
        <h2 class="-inset-1 font-medium text-base lg:text-xl">
          {{ 'JOIN US' | translate }}
        </h2>
        <ul>
          <li>
            <a routerLink="/in-progress" class="cursor-pointer">{{
              'Become a Vendor' | translate
            }}</a>
          </li>
          <li>
            <a routerLink="/in-progress" class="cursor-pointer">{{
              'Become a Driver' | translate
            }}</a>
          </li>
          <li>
            <a [href]="sellerDashboardUrl" class="cursor-pointer">{{
              'Become a Seller' | translate
            }}</a>
          </li>
        </ul>
      </nav>
    </div>
    <div
      class="f-reveal f-delay-2 flex flex-col lg:flex-row justify-between items-center relative gap-4"
    >
      <div class="gap-x-3 flex justify-center items-center">
        <a
          class="flex h-9 w-9 items-center justify-center rounded-full bg-[#2596BE] text-white"
          ><sham-i-social-facebook-1
        /></a>
        <a><sham-i-social-twitter-1 /></a>
        <a><sham-i-social-pinterest-1 /></a>
        <a><sham-i-social-instagram-1 /></a>
      </div>
      <div class="lg:order-last gap-x-2 flex">
        <sham-i-ApplePay />
        <sham-i-VisaPayment />
        <sham-i-discover-payment />
        <sham-i-mastercard-payment />
        <sham-i-secure-payment />
      </div>
      <div
        class="lg:absolute lg:end-1/2 lg:translate-x-1/2 rtl:lg:-translate-x-1/2 text-center text-white-dark-a"
      >
        {{ 'shamstore eCommerce' | translate }} &copy; 2026.
        {{ 'All Rights Reserved' | translate }}.
      </div>
    </div>
  </div>
</footer>
